



















































































import { Ref, Component, Emit, Watch } from 'nuxt-property-decorator'
import { filter, find, map } from 'lodash'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import { CodeTable } from '@/components/molecules/CodeTable2'
import { AlertMessage, ErrorMessage, jobApi, SystemCode } from '@/api'
import {
  alertStore,
  dataStore,
  modalCodeStore,
  modalErrorStore,
  modalJobListStore,
  systemCodeStore
} from '@/store'

import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { SystemCodeItem } from '@/types'
import { AtomTextField } from '@/components/atoms'

interface FilterCondition {
  code: string
  name: string
}

const defaultFilterCondition = (): FilterCondition => ({
  code: '',
  name: ''
})

@Component({
  components: {
    ModalFooter,
    CodeTable
  }
})
export default class ModalCode extends ModalComponentBaseVue {
  @Ref()
  codeTextField!: AtomTextField

  @Ref()
  nameTextField!: AtomTextField

  items: SystemCodeItem[] = []

  isAllSelect: boolean = false

  tableBodyHeight: number = 0

  filterCondition: FilterCondition = defaultFilterCondition()

  get codeMask(): string {
    return 'X'.repeat(this.codeLength)
  }

  get isOpen(): boolean {
    return modalCodeStore.isOpen
  }

  get title(): string {
    return modalCodeStore.title
  }

  get codeKey(): string {
    return modalCodeStore.codeKey
  }

  get systemCodes(): SystemCode[] {
    return modalCodeStore.systemCodes.filter(
      item => !this.exclusionCodes.includes(item.code)
    )
  }

  get systemCodesByStore(): SystemCode[] {
    return systemCodeStore.allItems.filter(
      item =>
        item.codeKey === this.codeKey &&
        !this.exclusionCodes.includes(item.code)
    )
  }

  get defaultCode(): string {
    return modalCodeStore.defaultCode
  }

  get multiple(): boolean {
    return modalCodeStore.multiple
  }

  get exclusionCodes(): string[] {
    return modalCodeStore.exclusionCodes
  }

  get disabledCodes(): string[] {
    return modalCodeStore.disabledCodes
  }

  get codeLength(): number {
    return modalCodeStore.codeLength
  }

  get filteredItems(): SystemCodeItem[] {
    const codeRegExp = new RegExp(`^${this.filterCondition.code}`)
    const nameRegExp = new RegExp(`${this.filterCondition.name}`)

    return this.items.filter(
      item =>
        !this.exclusionCodes.includes(item.code) &&
        (this.filterCondition.code === '' || item.code.match(codeRegExp)) &&
        (this.filterCondition.name === '' ||
          item.name.match(nameRegExp) ||
          item.shortName.match(nameRegExp))
    )
  }

  get iItemsLength(): number {
    return this.filteredItems.length
  }

  get existsFilteredItems(): boolean {
    return this.iItemsLength > 0
  }

  get selectedInternalItemLength(): number {
    return this.selectedItems.length
  }

  get selectedItems(): SystemCodeItem[] {
    return filter(this.filteredItems, { isSelected: true })
  }

  get filteredSystemCodes(): SystemCode[] {
    return this.systemCodes.length > 0
      ? this.systemCodes
      : this.systemCodesByStore
  }

  get defaultCodes(): string[] {
    if (this.defaultCode === '') return []

    return this.defaultCode
      .split(',')
      .filter(
        (value, index, array) => value !== '' && array.indexOf(value) === index
      )
  }

  @Watch('filteredItems')
  onFiltered(newVal: SystemCodeItem[]): void {
    this.items.forEach(
      item =>
        (item.isSelected =
          !this.disabledCodes.includes(item.code) &&
          item.isSelected &&
          newVal.some(value => value.code === item.code))
    )

    if (!this.multiple && newVal.every(item => !item.isSelected)) {
      newVal.forEach(
        (item: SystemCodeItem, index: number) => (item.isSelected = index === 0)
      )
    }
  }

  @Watch('isOpen')
  changeOpen(): void {
    this.init()
    if (this.isOpen) {
      this.$nextTick(() => {
        this.calculateTableHeight()

        // HACK ここでsetTimeoutしているのはバグを受容し、勝手なフォーカスの後に意図的なフォーカスを行う為
        // HACK バグとは「勝手にコード順に最初にフォーカスできるコンポーネントにフォーカスしてしまう」事を指す
        // HACK 現時点ではダイアログを開いた時、ダウンロードアイコンにフォーカスしてしまい、その部品を消すと次はcode入力欄にフォーカスする
        // HACK コメントアウトしながら確認した結果、InputCode.vueのAtomTextField.vueで何かが発生している可能性が高い
        // HACK 時間がない為対応できないが、後々修正対応を行いたい
        setTimeout(() => {
          this.focus()
        })
      })
    }
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.onResize)
  }

  focus(): void {
    if (dataStore.systemCodeDialogInitialFocusName) {
      this.nameTextField.atomTextField.focus()
    } else {
      this.codeTextField.atomTextField.focus()
    }
  }

  init(): void {
    this.isAllSelect = false
    this.filterCondition = defaultFilterCondition()
    this.createInternalItems()
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  createInternalItems() {
    this.debug('createInternalItems()')

    if (this.filteredSystemCodes.length === 0) return

    const selectedSystemCodes = filter(
      this.filteredSystemCodes,
      (item: SystemCode) => {
        return (
          item.code !== undefined && this.defaultCodes.includes(item.code || '')
        )
      }
    )

    this.items = map(this.filteredSystemCodes, (item: SystemCode) => {
      const findItem = find(selectedSystemCodes, { code: item.code })
      return Object.assign(item, { isSelected: !!findItem })
    })

    const firstIndex: number = this.items.findIndex(
      item => item.id === this.filteredItems[0]?.id
    )

    if (!this.multiple && this.defaultCodes.length === 0 && ~firstIndex) {
      this.items[firstIndex].isSelected = true
    }
  }

  toggleItems(value: boolean) {
    this.items = map(this.filteredSystemCodes, (item: SystemCode) => {
      return Object.assign(item, { isSelected: value })
    })
  }

  onClickOk(): void {
    if (this.multiple) {
      modalCodeStore.ok(
        this.selectedItems.map(value => {
          return {
            id: value.id,
            codeKey: value.codeKey,
            code: value.code,
            name: value.name,
            shortName: value.shortName,
            option1: value.option1,
            option2: value.option2,
            option3: value.option3,
            option4: value.option4,
            option5: value.option5,
            option6: value.option6
          }
        })
      )
      return
    }

    modalCodeStore.ok(
      this.selectedItems.length > 0
        ? {
            id: this.selectedItems[0].id,
            codeKey: this.selectedItems[0].codeKey,
            code: this.selectedItems[0].code,
            name: this.selectedItems[0].name,
            shortName: this.selectedItems[0].shortName,
            option1: this.selectedItems[0].option1,
            option2: this.selectedItems[0].option2,
            option3: this.selectedItems[0].option3,
            option4: this.selectedItems[0].option4,
            option5: this.selectedItems[0].option5,
            option6: this.selectedItems[0].option6
          }
        : null
    )
  }

  onClickCancel(): void {
    modalCodeStore.cancel()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-code')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onAllSelectCode(value: boolean): void {
    this.isAllSelect = value
    this.toggleItems(this.isAllSelect)
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  async downloadSystemCodeExcel(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const jobId = await jobApi.createSystemCodeList({
        codeKey: this.codeKey
      })

      await modalJobListStore.newJobId(jobId)
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  @Emit('change')
  onSelectCode(code: string): void {
    if (!this.multiple) {
      this.toggleItems(false)
    }

    const item: SystemCodeItem | undefined = find(
      this.filteredItems,
      (item: SystemCodeItem) => {
        return item.code === code
      }
    )

    if (item === undefined) return

    item.isSelected = !item.isSelected

    this.items.splice(this.items.indexOf(item), 1, item)
  }
}
